module.exports = __webpack_public_path__ + "octicons.ttf?e0d4a324833e13be7d4fa762146d0a71";


/*****************
 ** WEBPACK FOOTER
 ** ./~/octicons/build/font/octicons.ttf?ef21c39f0ca9b1b5116e5eb7ac5eabe6
 ** module id = 123
 ** module chunks = 0
 **/